<template>
  <!-- This entire component is a hack to make a btn adhere to validation rules by vuetify, it should be completely rethought when time permits -->
  <button
    :class="{
      checked: modelValue,
    }"
    type="button"
  >
    {{ txt }}
    <v-checkbox v-model="modelValue" :rules="rules" />
  </button>
</template>
<script>
export default {
  name: 'BtnCheckbox',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    txt: {
      type: String,
      required: true
    }
  },
  emits: ['input'],
  data () {
    return { rules: [(v) => !!v || ''] }
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" setup scoped>
button {
  position: relative;

  &:has(.error--text) {
    color: red;
    border: solid 1px red;
  }
}

.v-input {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}

.checked {
  border: 1px solid #0078a7;
  background-color: #f1f6f8;
}
</style>



// WEBPACK FOOTER //
// src/components/globalUiComponents/btn/BtnCheckbox.vue